import styles from './circle.module.css';

const Circle = ({children, circleColor = "rgba(98, 141, 205, 1)", width='50px', height='50px'}) => (
    <div className={styles.circle} style={{backgroundColor: circleColor, width, height}}>
        {children}
    </div>
)

export default Circle;
